import { defineComponent, useSlots, ref, computed, onMounted, onBeforeUnmount, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, withDirectives, createVNode, mergeProps, createSlots, renderList, unref, withCtx, renderSlot, normalizeProps, guardReactiveProps, vShow, nextTick } from "vue";
import AppHeader from "../app-header/AppHeader.vue.js";
import MainLayout from "./MainLayout.vue.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AuthorizedLayout",
  props: {
    showBack: { type: Boolean },
    backText: {},
    title: {},
    description: {},
    menuOpenTitle: {},
    menuOpenIcon: {},
    preventMenuClose: { type: Boolean },
    logo: {},
    items: {},
    notificationItems: {},
    notificationBadgeCount: {},
    showNotificationBadge: { type: Boolean },
    showDesktopNotification: { type: Boolean },
    maxVisibleItems: {},
    maxVisibleSecondaryItems: {},
    activeItem: {},
    activeSecondaryItem: {},
    currentPath: {},
    mobileShowMenuButton: { type: Boolean },
    mobileCompactHeader: { type: Boolean },
    mobileTitle: {},
    showMenuButton: { type: Boolean },
    menuButtonLabel: {},
    menuIcon: {},
    profileAccounts: {},
    profileMenuItems: {},
    profileModelValue: {},
    profileSearchable: { type: Boolean },
    profileSearchPlaceholder: {},
    userName: {},
    userEmail: {},
    userAvatar: {},
    userDisplayMode: {},
    isAdmin: { type: Boolean },
    showProfile: { type: Boolean },
    responsive: { type: Boolean }
  },
  emits: ["navigate", "navigateSecondary", "logoClick", "profile:select", "profile:update:modelValue", "notification:click", "notification:item-click", "back", "menu-button-click"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const slots = useSlots();
    const emit = __emit;
    const showHeader = ref(true);
    const headerHeight = ref(64);
    const appHeaderRef = ref(null);
    const contentRef = ref(null);
    let headerResizeObserver = null;
    const layoutClass = computed(() => ({
      "authorized-layout--no-header": !showHeader.value
    }));
    const appHeaderProps = computed(() => {
      const {
        logo,
        items,
        notificationItems,
        notificationBadgeCount,
        showNotificationBadge,
        maxVisibleItems,
        maxVisibleSecondaryItems,
        activeItem,
        activeSecondaryItem,
        currentPath,
        // Mobile compact header
        mobileShowMenuButton,
        mobileCompactHeader,
        mobileTitle,
        menuOpenTitle,
        // Menu Button
        showMenuButton,
        menuButtonLabel,
        menuIcon,
        menuOpenIcon,
        preventMenuClose,
        // Profile Dropdown - New Structure
        profileAccounts,
        profileMenuItems,
        profileModelValue,
        profileSearchable,
        profileSearchPlaceholder,
        // Profile Dropdown - Legacy Support
        userName,
        userEmail,
        userAvatar,
        userDisplayMode,
        isAdmin,
        showProfile,
        responsive
      } = props;
      return {
        logo,
        items,
        notificationItems,
        notificationBadgeCount,
        showNotificationBadge,
        maxVisibleItems,
        maxVisibleSecondaryItems,
        activeItem,
        activeSecondaryItem,
        currentPath,
        // Mobile compact header
        mobileShowMenuButton,
        mobileCompactHeader,
        mobileTitle,
        menuOpenTitle,
        // Menu Button
        showMenuButton,
        menuButtonLabel,
        menuIcon,
        menuOpenIcon,
        preventMenuClose,
        // Profile Dropdown - New Structure
        profileAccounts,
        profileMenuItems,
        profileModelValue,
        profileSearchable,
        profileSearchPlaceholder,
        // Profile Dropdown - Legacy Support
        userName,
        userEmail,
        userAvatar,
        userDisplayMode,
        isAdmin,
        showProfile,
        responsive
      };
    });
    function getHeaderDomEl() {
      const raw = appHeaderRef.value;
      if (!raw) return null;
      return raw.$el || raw;
    }
    function updateHeaderHeight() {
      nextTick(() => {
        const headerEl = getHeaderDomEl();
        if (headerEl instanceof HTMLElement) {
          const height = headerEl.offsetHeight;
          if (height > 0) {
            headerHeight.value = height;
          }
        }
      });
    }
    function handleScroll(event) {
      const target = event.target;
      if (!target) return;
      showHeader.value = target.scrollTop <= 5;
    }
    onMounted(() => {
      updateHeaderHeight();
      const headerEl = getHeaderDomEl();
      if (headerEl && window.ResizeObserver) {
        headerResizeObserver = new ResizeObserver(updateHeaderHeight);
        headerResizeObserver.observe(headerEl);
      }
    });
    onBeforeUnmount(() => {
      if (headerResizeObserver) {
        headerResizeObserver.disconnect();
      }
    });
    __expose({
      appHeaderRef,
      contentRef,
      showHeader
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["authorized-layout", layoutClass.value])
      }, [
        createElementVNode("div", {
          class: "authorized-layout__header-wrapper",
          style: normalizeStyle({
            blockSize: showHeader.value ? `${headerHeight.value}px` : "0px",
            opacity: showHeader.value ? 1 : 0,
            marginBlockEnd: showHeader.value ? "8px" : "0px",
            pointerEvents: showHeader.value ? "auto" : "none",
            overflow: showHeader.value ? "visible" : "hidden"
          })
        }, [
          withDirectives(createVNode(AppHeader, mergeProps(appHeaderProps.value, {
            ref_key: "appHeaderRef",
            ref: appHeaderRef,
            "menu-open-title": __props.menuOpenTitle,
            "menu-open-icon": __props.menuOpenIcon,
            "prevent-menu-close": __props.preventMenuClose,
            "show-desktop-notification": false,
            onNavigate: _cache[0] || (_cache[0] = (item) => emit("navigate", item)),
            onNavigateSecondary: _cache[1] || (_cache[1] = (item) => emit("navigateSecondary", item)),
            onLogoClick: _cache[2] || (_cache[2] = () => emit("logoClick")),
            "onProfile:select": _cache[3] || (_cache[3] = (account) => emit("profile:select", account)),
            "onProfile:update:modelValue": _cache[4] || (_cache[4] = (value) => emit("profile:update:modelValue", value)),
            "onNotification:click": _cache[5] || (_cache[5] = () => emit("notification:click")),
            "onNotification:itemClick": _cache[6] || (_cache[6] = (item) => emit("notification:item-click", item)),
            onMenuButtonClick: _cache[7] || (_cache[7] = (isOpen) => emit("menu-button-click", isOpen))
          }), createSlots({ _: 2 }, [
            renderList(unref(slots), (_, name) => {
              return {
                name,
                fn: withCtx((slotProps) => [
                  renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotProps)), void 0, true)
                ])
              };
            })
          ]), 1040, ["menu-open-title", "menu-open-icon", "prevent-menu-close"]), [
            [vShow, true]
          ])
        ], 4),
        createElementVNode("div", {
          ref_key: "contentRef",
          ref: contentRef,
          class: "authorized-layout__content",
          style: normalizeStyle({
            minBlockSize: showHeader.value ? `unset` : "calc(100dvh - 0.75rem)",
            paddingBlockEnd: !showHeader.value ? `${headerHeight.value + 8}px` : void 0
          }),
          onScroll: handleScroll
        }, [
          createVNode(MainLayout, {
            "show-back": props.showBack,
            "back-text": props.backText,
            title: props.title,
            description: props.description,
            onBack: _cache[8] || (_cache[8] = () => emit("back"))
          }, createSlots({
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ]),
            _: 2
          }, [
            _ctx.$slots.title ? {
              name: "title",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "title", {}, void 0, true)
              ]),
              key: "0"
            } : void 0,
            _ctx.$slots.description ? {
              name: "description",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "description", {}, void 0, true)
              ]),
              key: "1"
            } : void 0,
            _ctx.$slots.actions ? {
              name: "actions",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "actions", {}, void 0, true)
              ]),
              key: "2"
            } : void 0,
            _ctx.$slots.filters ? {
              name: "filters",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "filters", {}, void 0, true)
              ]),
              key: "3"
            } : void 0,
            _ctx.$slots.breadcrumbs ? {
              name: "breadcrumbs",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "breadcrumbs", {}, void 0, true)
              ]),
              key: "4"
            } : void 0,
            _ctx.$slots.footer ? {
              name: "footer",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "footer", {}, void 0, true)
              ]),
              key: "5"
            } : void 0
          ]), 1032, ["show-back", "back-text", "title", "description"])
        ], 36)
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AuthorizedLayout.vue2.js.map
